import { Alert, Typography } from "@mui/material"
import * as env from "lib/env"
import { useState } from "react"
import * as styles from "./EnvironmentDebug.styles"

type Props = {
    title: string
    details: string
}

const DebugContext = (props: Props) => {
    return (
        <Typography variant="bodySmall" component={"div"}>
            <strong>{props.title}: </strong>
            {props.details}
        </Typography>
    )
}

const EnvironmentDebug: React.FC = () => {
    const [show, setShow] = useState(true)

    if (env.ENV === "production") {
        return null
    }

    if (!show) {
        return null
    }

    return (
        <Alert
            css={styles.alert}
            severity="error"
            onClose={() => {
                setShow(false)
            }}
        >
            <DebugContext title="Environment" details={env.ENV} />
            <DebugContext title="Ref Type" details={env.GITHUB_REF_TYPE} />
            <DebugContext title="Ref Name" details={env.GITHUB_REF_NAME} />
            <DebugContext title="Head Ref" details={env.GITHUB_HEAD_REF} />
        </Alert>
    )
}

export default EnvironmentDebug
